<template>
  <v-container class="mt-3">
    <div>
      <v-data-table
        :headers="headers"
        :items="frequency"
        :page.sync="page"
        :items-per-page="5"
        @page-count="pageCount = $event"
        class="text-left elevation-1 pa-3 font-weight-regular blue--text text--darken-4"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Presença</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="primary subtitle-2 font-weight-light"
              dark
              class="mb-2"
              style="text-transform:none"
              @click="openDialog()"
            >
              <v-icon size="25" left>add</v-icon>Lançar presença
            </v-btn>
          </v-toolbar>

          <v-divider></v-divider>

          <v-list-item v-if="selectedNurse">
            <v-list-item-avatar
              class="text-center"
              :color="!selectedNurse.avatar ? 'teal accent-3':''"
            >
              <v-img v-if="selectedNurse.avatar" src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
              <span
                v-else
                class="mx-auto text-center white--text headline"
              >{{selectedNurse.name[0]}}</span>
            </v-list-item-avatar>
            <v-list-item-content style="color:#6C7293">
              <v-list-item-title class="font-weight-medium">{{selectedNurse.name}}</v-list-item-title>
              <v-list-item-subtitle>{{[selectedNurse.occupation,selectedNurse.base].join(" - ")}}</v-list-item-subtitle>
              <v-list-item-subtitle>{{selectedNurse.email}}</v-list-item-subtitle>
              <v-list-item-subtitle>{{selectedNurse.phone}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-slot:item.date="{ item }">
          <span>{{utils.formatDate( item.date)}}</span>
        </template>

        <template v-slot:item.present="{ item }">
          <span>
            <v-icon small :color="item.present ? 'green lighten-1':'red darken-3'">far fa-dot-circle</v-icon>
          </span>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </div>
    <v-dialog v-model="launchPresenceDialog" width="500">
      <v-card class="py-5" style="color:#6C7293">
        <h1 class="title font-weight-regular text-center mt-5 mb-12">Lançar presença</h1>

        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="4">Data</v-col>
              <v-col cols="8">
                <v-menu v-model="menuData" :close-on-content-click="false" max-width="290">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      class="py-0 my-0"
                      :value="utils.formatDate(date)"
                      label="Data da frequência"
                      readonly
                      :rules="[dateRules]"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    @change="menuData = false"
                    color="green darken-1"
                    locale="pt-br"
                    :min="dateMin()"
                    :max="dateMax()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">Frequência</v-col>
              <v-col cols="8">
                <v-radio-group class="py-0 my-0" v-model="present" row>
                  <v-radio label="Presente" :value="true" color="green darken-1"></v-radio>
                  <v-radio label="Ausente" :value="false" color="green darken-1"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="font-weight-regular"
            color="pink lighten-1 white--text"
            style="text-transform:none"
            width="150"
            @click="launchPresenceDialog = false"
          >Cancelar</v-btn>
          <v-btn
            class="font-weight-regular"
            :loading="loading"
            color="teal accent-4 white--text"
            style="text-transform:none"
            width="150"
            @click="launchPresence()"
          >Registrar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import utils from "../../../utils/functions";
import moment from "moment";
export default {
  props: ["id"],
  data: () => ({
    headers: [
      {
        text: "Data",
        align: "start",
        sortable: false,
        value: "date",
        width: "100px"
      },
      {
        text: "Presente",
        value: "present",
        sortable: false,
        align: "center",
        width: "100px"
      }
    ],
    page: 1,
    pageCount: 0,
    utils: utils,
    launchPresenceDialog: false,
    menuData: false,
    date: moment().format("YYYY-MM-DD"),
    present: true,
    loading: false,
    
  }),
  computed: {
    selectedNurse() {
      return this.$store.getters.nursingStaff[this.id];
    },
    dateRules(){
      let index = this.frequency.findIndex((value)=>value.date === this.date)
      if(index != -1)
        return 'Data já lançada!'
      
      return null
    },
    frequency() {
      return this.$store.getters.nursingStaff[this.id].frequency;
    }
  },
  methods: {
    openDialog(){
      this.launchPresenceDialog = true
      if(this.$refs.form)
        this.$refs.form.resetValidation()
    },
    launchPresence() {
      if(this.$refs.form.validate()){
        this.loading = true;
        this.$store.dispatch("addNewFrequency", {
          id: this.id,
          date: this.date,
          present: this.present
        });
        this.loading = false;
        this.launchPresenceDialog = false;
        this.clearLauchedFrequency();
      }
    },
    clearLauchedFrequency() {
      (this.date = moment().format("YYYY-MM-DD")), (this.present = true);
      this.$refs.form.resetValidation()
    },
    dateMax() {
      return moment().format("YYYY-MM-DD");
    },
    dateMin() {
      return moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD");
    },
  }
};
</script>
<style scoped>
.btn {
  text-transform: none;
}
</style>